import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../interface/ApplicationState';
import { updateLocalUser } from '../../redux/actions/userActions';
import { alpha, useTheme } from '@mui/material';
import { CandleStickIntervalChooser } from '../../components/CandleStickIntervalChooser';
import { dayTrader, swingTrader, positionTrader } from '../../const';


export const CandleStickSettings = () =>
{
  const dispatch = useDispatch();
  const user = useSelector((state: ApplicationState) => state.userStore.user)
  const theme = useTheme()

  return(
    <Card sx={localStyles.card(theme)}>


    <Typography variant="body2" sx={localStyles.copy(theme)}>Default 1 minute.
      This is used to summarise the current order closes by time buckets. 
      Smaller buckets means the bot will be more sensitive to changes in the market.</Typography>

    
    <Grid item container>
      <CandleStickIntervalChooser title="Day trader (Dozens of trades per day)" items={dayTrader} currentCheckedItem={user.chartInterval || ""} onItemChanged={(interval) => dispatch(updateLocalUser({ chartInterval: interval }))} />
      <CandleStickIntervalChooser title="Swing Trader (Fewer trades (1-10 a day)" items={swingTrader} currentCheckedItem={user.chartInterval || ""} onItemChanged={(interval) => dispatch(updateLocalUser({ chartInterval: interval }))} />
      <CandleStickIntervalChooser title="Position trader (Few trades)" items={positionTrader} currentCheckedItem={user.chartInterval || ""} onItemChanged={(interval) => dispatch(updateLocalUser({ chartInterval: interval }))} />
    </Grid>

    </Card>
  )
}

const localStyles = {
  card: (theme: any) => ({
    backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.03 : 0.74),
    borderRadius: "16px",
    border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === "dark" ? 0.08 : 0.55)}`,
    padding: 2.5,
    boxShadow: "none",
  }),
  copy: (theme: any) => ({
    color: alpha(theme.palette.text.primary, 0.68),
    mb: 2,
  }),
}
